<template>
    <div id="login">
        <div id="form">
            <p id="title">登录</p>
            <div class="line">
                <img src="@/assets/man.png">
                <input v-model="account" class="input" type="text" placeholder="账号">
            </div>
            <div class="line">
                <img src="@/assets/lock.png">
                <input v-model="password" class="input" type="password" placeholder="密码">
            </div>
            <div class="line">
                <el-checkbox v-model="checked" label="记住密码" name="type"></el-checkbox>
            </div>

            <div>
                <button @click="login">确认</button>
            </div>
        </div>
        <div id="shadow" @click="$store.commit('changeLoginButton')">

        </div>
    </div>
</template>
<script>
export default {
  name: "login",
  data() {
    return {
      account:"",
      password: "",
      checked: true
    };
  },
  created(){
    this.account=localStorage.account;
    this.password=localStorage.password;
  },
  methods: {
    async login() {
      let res = await this.$net.index.login({
        Username: this.account,
        Password: this.password
      });
      if (res.ErrorCode == 0) {
        if (this.checked) {
          localStorage.account = this.account;
          localStorage.password = this.password;
        } else {
          localStorage.removeItem('account');
          localStorage.removeItem('password');
        }
        localStorage.Authorization = res.Token;
        alert("登录成功!");
        this.$store.commit("changeLoginButton");
        // 登陆完刷新，使需要登录的内容正常显示
        this.$router.go(0)
      }
    }
  }
};
</script>
<style lang="scss">
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: green !important;
  border-color: green !important;
}
.el-checkbox__label {
  color: black !important;
}
</style>

<style lang="scss" scoped>
#login {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  z-index: 10;
}
#shadow {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 100;
}
#form {
  position: relative;
  width: 584px;
  height: 625px;
  margin: 150px auto;
  background: white;
  z-index: 1000;
  text-align: center;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  #title {
    font-size: 48px;
    font-family: "楷体 Bold", "楷体";
    font-weight: 700;
    font-style: normal;
    letter-spacing: 2px;
  }
  .line {
    display: flex;
    position: relative;
    width: 70%;
    margin: 30px 0;
    margin-left: 15%;
    height: 28px;
    img {
      width: 28px;
      height: 28px;
      position: absolute;
    }
    .input {
      width: 100%;
      padding: 5px;
      border: 0;
      padding-left: 48px;
      border-bottom: 1px #b4b4b4 solid;
      color: black;
      height: 28px;
      font-size: 20px;
    }
    .checkbox {
      background: green;
    }
  }
}
button {
  width: 300px;
  height: 45px;
  background-color: #339fdc;
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: #aaaaaa;
  border-radius: 3px;
  font-size: 20px;
  color: #ffffff;
  cursor: pointer;
}
</style>


